import { tokens } from "@cobee/cobee-ui";
import { makeStyles } from "@material-ui/core/styles";
import { darken } from "polished";
import { grey300 } from "../../../../infrastructure/theme/customColors";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
  container: {
    outline: "none",
    display: "flex",
    flexDirection: "column",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: ({ horizontalPadding }) =>
      `${theme.spacing(3)}px ${theme.spacing(horizontalPadding)}px`,
    borderRadius: 4,
    outline: "none",
    maxHeight: "calc(100vh - 60px)",
    maxWidth: "calc(100vw - 60px)",
    overflowY: "scroll",
    "&::-webkit-scrollbar": {
      display: "none",
    },

    "&:focus": {
      outline: "none",
    },
  },
  closeButton: {
    color: tokens.palette.grey[700],
    fontSize: 18,
    cursor: "pointer",
  },
  disabled: {
    backgroundColor: grey300,
    color: darken(0.2, grey300),
    cursor: "context-menu",

    "&:hover": {
      backgroundColor: grey300,
      cursor: "context-menu",
    },
  },
}));

export default useStyles;
